import { InjectionToken } from '@angular/core';

import {
    BaseEvent,
    CoachingEventType,
    DeliveryType,
    EventResult,
    FocusContainerRefDto,
    NoteDetails,
} from '../../coaching-base/general';
import { FocusShallow } from '../../coaching-tags/tags/tags.model';

/// ///////

// TODO revise. separate component for readonly
export const READONLY_OBSERVATION = new InjectionToken<any>(
    'READONLY_OBSERVATION',
);

export interface ReadonlyObservation {
    value: boolean;
}

export const ReadonlyObservationContainer: ReadonlyObservation = {
    value: true,
};

/// ///////

/**
 * switching from DEFAULT or POP_UP to any other mode during the lifetime of the observation instance must not be done.
 * only switching between REVIEW_READ_ONLY and REVIEW_EDIT is supported
 */
export enum ObservationMode {
    DEFAULT,

    /** stand alone observation form in a pop-up */
    POP_UP,

    REVIEW_READ_ONLY,
    REVIEW_EDIT,
}

export interface ObservationFormDisplayProperties {
    stopScrollHeight?: boolean;
    hideBehaviour?: boolean;
    hideSubbehaviour?: boolean;
    hideEvaluations?: boolean;
    hideContextMenu?: boolean;
    hideNavigator?: boolean;
    hideFocusTooltip?: boolean;
    diableExpandFocus?: boolean;
}

export interface AllowedActions {
    cancel?: boolean;
    share?: boolean;
    edit?: boolean;
    delete?: boolean;
    publish?: boolean;
    save?: boolean;

    // TODO revise. only tag-groups is using these 4 in the extended
    addNote?: boolean;
    addInteraction?: boolean;

    displayNotes?: boolean;
    displayInteractions?: boolean;
}

export interface EnabledActions {
    cancel?: boolean;
    share?: boolean;
    edit?: boolean;
    delete?: boolean;
    publish?: boolean;
    save?: boolean;
}

/** @internal */
export enum NavigationScenario {
    NEWLY_SAVED = 1,
    NEWLY_PUBLISHED_STAY,
    NEWLY_PUBLISHED_NAVIGATE,
    NO_FOCUS_SUPPLIED_NEWLY_PUBLISHED_LINK,
    FOCUS_SUPPLIED_NEWLY_PUBLISHED_LINK,
    COMMITMENT,
    DELETE,

    /** only for use by transcript-dialog component */
    POP_UP__FOCUS_SUPPLIED__NEWLY_PUBLISHED__PILLAR_3_NO_COMMITMENT_LOADED,

    /** only for use by transcript-dialog component */
    POP_UP__FOCUS_SUPPLIED__NEWLY_PUBLISHED__PILLAR_3_HAS_COMMITMENT_LOADED,

    /** only for use by transcript-dialog component */
    POP_UP__NO_FOCUS_SUPPLIED__NEWLY_PUBLISHED__PILLAR_3_NO_COMMITMENT_LOADED,

    /** only for use by transcript-dialog component */
    POP_UP__NO_FOCUS_SUPPLIED__NEWLY_PUBLISHED__PILLAR_3_HAS_COMMITMENT_LOADED,
}

export interface NavigationScenarioOptions {
    /** focus to use when starting a new commitment or updating an existing commitment */
    focus?: FocusShallow;

    /** for linking a focus container from an observation to a new or existing commitment */
    withObservationId?: boolean;

    /** for linking a focus container from an observation to an existing commitment */
    commitmentId?: number;
}

export interface CoachingInteraction {
    interactionId: number;
    interactionIdentifier: string;
    interactionTypeId: number;
    interactionPurposeId: number;
    performerId: number;
    observerId: number;
    interactionDateTime: Date;
    queueId: number;
    createdBy: number;
    createdOn: Date;
    updatedBy?: number;
    updatedOn?: Date;
    // public InteractionType InteractionType { get; set; }
    // public virtual ICollection<InteractionScoring> Scoring { get; set; }
}

export interface InteractionScoring {
    scoringConfigurationId: number;
    interactionScoringId: number;
    interactionId: number;
    focusDelivered: number;
    opportunityToDemonstrate?: boolean;
    willingnessToTry?: boolean;
    proficiencyDelivered?: number;
    consistencyDelivered?: number;
    confidenceDelivered?: number;
    focusId: number; // tagId
    // public CoachingInteraction Interaction { get; set; }
    // public Tag Focus { get; set; }
}

export interface InteractionScoringModel extends InteractionScoring {
    notes: NoteDetails[];
    behaviour?: number;
    subBehaviour?: number;
    metricId?: number;
    queueId?: number;
}

export interface CoachingInteractionModel extends CoachingInteraction {
    notes: NoteDetails[];
    scoring: InteractionScoringModel[];
}

export interface ObservationEvent extends BaseEvent {
    interactions: CoachingInteractionModel[];
    notes: NoteDetails[]; // TODO remove. root notes no longer used?

    /*
     * this is temporary for the use of managing focus containers
     * ideally the posted model for observation update should be similar to the newer ObservationDto. but... time
     */
    focusContainers: FocusContainerRefDto[];
}

// TODO move?
export interface Tag {
    tagId: number;
    performerId: number;
    behaviour?: number;
    subBehaviour?: number;
    metricId?: number;
    queueId?: number;
    createdBy: number;
    createdOn: Date;
}

// TODO revise
export interface EventParticipant {
    fullName?: string;
    eventId?: number;
    userId: number;
    coachingRoleId: number;
    event?: Event;
}

/* // TODO move?
// Coaching.Config_InteractionType.InteractionTypeName
export enum InteractionType {
    CALL = 1,
    CHAT,
    IN_PERSON,
    EMAIL
} */

/// /

export function createEvent(): EventResult {
    const now = new Date();
    return {
        eventId: null,
        eventTypeId: CoachingEventType.OBSERVATION,
        deliveryTypeId: DeliveryType.SIDE_BY_SIDE,
        sessionDate: now,
        duration: 1,
        shareWithPerformer: false,
        published: false,
        createdBy: null,
        createdOn: null,
        updatedBy: null,
        updatedOn: null,
        startTime: now,
        endTime: null,
        deleted: null,

        // TODO remove
        eventTypeFullName: null,
        eventTypeShortName: null,
        eventTypeInitials: null,
        deliveryTypeFullName: null,
        deliveryTypeShortName: null,
        deliveryTypeInitials: null,
    };
}
